import { render, staticRenderFns } from "./JwsVehicleView.vue?vue&type=template&id=4d5d8922"
import script from "./JwsVehicleView.vue?vue&type=script&lang=js"
export * from "./JwsVehicleView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports